import Alert, {AlertType} from 'features/POSRegisters/interfaces/AlertInfo';
import ScanDetails from 'features/POSRegisters/interfaces/ScanDetails';
import Device from '../interfaces/Device';

export function hasAssociation(scanResults: Partial<ScanDetails>) {
  if (!scanResults) return false;
  const {isAssociated, associatedDevice} = scanResults;
  return isAssociated === true && associatedDevice === 'unavailable' ? false : isAssociated;
}

export function checkIsScanFailureAlert({alertType, siteImpact}: Alert) {
  return (
    alertType === AlertType.SCAN_FAILURE_ALERT ||
    siteImpact.toUpperCase() === AlertType.SCAN_FAILURE_ALERT.toUpperCase()
  );
}
export function checkIsOrphanDeviceAlert({alertType}: Alert) {
  return alertType === AlertType.ORPHAN_DEVICE_ALERT;
}

export function checkIsConfigurationDeviceAlert({alertType}: Alert) {
  return alertType === AlertType.CONFIGURATION_ALERT;
}

export function getSeverityString(alert: Alert) {
  if (checkIsScanFailureAlert(alert)) {
    return 'Scan Failure';
  } else if (checkIsOrphanDeviceAlert(alert)) {
    return 'Orphan Device';
  } else if (checkIsConfigurationDeviceAlert(alert)) {
    return 'Configuration Issue';
  } else {
    return alert.siteImpact?.toUpperCase();
  }
}

export function hasDeviceInformation(devices: Device<ScanDetails>[]) {
  return devices.some(
    device => hasAssociation(device?.scanResults) || device?.scanResults?.isSupported === false
  );
}
